<script setup>
import {ref, watch} from 'vue';

const props = defineProps({
    src: {
        type: String,
        default: '',
    },
    alt: {
        type: String,
        default: '',
    },
    variant: {
        type: String,
        default: 'vehicle',
    },
});

const isLoaded = ref(false);

watch(() => props.src, () => {
    isLoaded.value = false;
});
</script>

<template>
    <div
        class="configurator-card-image"
        :class="[
            `configurator-card-image--${variant}`,
            {'is-loaded': isLoaded},
        ]"
    >
        <img
            :src="src"
            :alt="alt"
            class="card-config-bg"
            :class="{'is-loaded': isLoaded}"
            @load="isLoaded = true"
            @error="isLoaded = false"
        >
    </div>
</template>

<style scoped>
.configurator-card-image {
    position: relative;
    width: 100%;
    height: 115px;
    overflow: hidden;
    border-radius: 5px 5px 0 0;
}

.configurator-card-image--circuit {
    width: 75%;
}

.card-config-bg {
    position: relative;
    width: 100% !important;
    opacity: 0;
    transition: opacity 150ms ease-in;
}

.card-config-bg.is-loaded {
    opacity: 1;
}

</style>
